// Landing page entrypoint - includes Tailwind CSS
import '../dashboard/assets/scss/_woot.scss';

// Handle dark mode based on system preference
const setColorTheme = () => {
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
};

// Initial setup
setColorTheme();

// Listen for theme changes
window
  .matchMedia('(prefers-color-scheme: dark)')
  .addEventListener('change', setColorTheme);
